import React, { useEffect } from "react";
import { connect } from "react-redux";

import { _fetchFollowing, _followUnfollow } from "../../store/follow/actions";
import { Link } from "react-router-dom";
import "./Following.scss";

const Following = (props) => {
  useEffect(async () => {
    await props._fetchFollowing();
  }, []);
  const followUnfollow = async (id) => {
    await props._followUnfollow(id);
    props._fetchFollowing();
  };
  return (
    <div className="Following">
      <h1 className=" font-weight-bold text-black-50 mb-5 pb-3 border-bottom w-100 text-left">
        Following
      </h1>
      {!props.following.isLoading && props.following.isFollowingLoaded
        ? props.following.following.map((follower) => (
            <div className="list p-4 d-flex justify-content-between align-items-center flex-column flex-md-row m-2 m-md-4 border-circle shadow">
              <div className="left d-flex  justify-content-start align-items-center flex-column flex-md-row">
                <img
                  src="/images/bg/2b5be3f5db32c1dbfd5702da8af2f247.webp"
                  alt=""
                  className="img"
                />
                <div className="">
                  <h4>{follower?.followed?.name}</h4>
                </div>
              </div>
              <h3 className="text-muted">{follower?.followed?.music_genre}</h3>
              <div>
                <button
                  className="btn outline m-0"
                  onClick={() => {
                    followUnfollow(follower?.followed?._id);
                  }}
                >
                  Unfollow
                </button>
                <Link to={`/view-profile/${follower?.followed?._id}`}>
                  <button className="btn outline mx-2">View Profile</button>
                </Link>
              </div>
            </div>
          ))
        : "Loading..."}
    </div>
  );
};
const mapStateToProps = (state) => ({
  following: state.follow,
});

export default connect(mapStateToProps, {
  _fetchFollowing,
  _followUnfollow,
})(Following);
